import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '@jht/brand-pipes';
import { TranslateModule } from '@jht/brand-translate';

import { BASE_SUFFIXES } from '../translation-suffixes';
import { PartialsHelpersService } from '../partials-helpers.service';
import { CardComponent } from '../../../shared/components/card/card.component';
import { SideBySideComponent } from '../../../shared/components/side-by-side/side-by-side.component';
import { InlineBannerComponent } from '../../../shared/components/inline-banner/inline-banner.component';

@Component({
    selector: 'vision2-section-3',
    imports: [
        CommonModule,
        PipesModule,
        TranslateModule,
        CardComponent,
        InlineBannerComponent,
        SideBySideComponent,
    ],
    templateUrl: './section-3.component.html',
    styleUrl: './section-3.component.scss',
})
export class Section3Component implements OnChanges {
    @Input() productData: any;
    groupedContent: Record<string, any[]> = {};
    hasValidTranslations = false;

    constructor(private helpers: PartialsHelpersService) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.getTranslations();
    }

    getTranslations(): void {
        this.groupedContent = {
            'SECTION-3': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-3',
                BASE_SUFFIXES,
                [],
            ),
            'SECTION-3_SIDE-BY-SIDE-overview':
                this.helpers.translateContentGroup(
                    this.productData,
                    'SECTION-3_SIDE-BY-SIDE',
                    BASE_SUFFIXES,
                    [0],
                ),
            'SECTION-3_SIDE-BY-SIDE': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-3_SIDE-BY-SIDE',
                BASE_SUFFIXES,
                [1, 2, 3],
            ),
            'SECTION-3_INLINE-BANNER': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-3_INLINE-BANNER',
                BASE_SUFFIXES,
                [0, 1],
            ),
            'SECTION-3_CONTENT-BLOCK': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-3_CONTENT-BLOCK',
                BASE_SUFFIXES,
                [0, 1, 2],
            ),
        };

        this.hasValidTranslations = this.helpers.hasValidTranslation(
            this.groupedContent,
        );
    }
}
